import { render, staticRenderFns } from "./AppConfirm.vue?vue&type=template&id=23ca442a&"
import script from "./AppConfirm.vue?vue&type=script&lang=js&"
export * from "./AppConfirm.vue?vue&type=script&lang=js&"
import style0 from "./AppConfirm.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports